import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import './css/index.scss';

import {
  Input,
  Form,
  Button,
  Row,
  Col
} from '@lockerpm/design';

import authComponents from "./components";
import commonComponents from "../../components/common";
import itemsComponents from "../../components/items";

import commonServices from "../../services/common";
import authServices from "../../services/auth";
import userServices from "../../services/user";

import global from "../../config/global";
import { convertStringToQuery, getRouterByLocation } from '../../secrets-web/src/utils/common';
import { fetchUserInfo } from '../../utils/common'

const Lock = () => {
  const { UserInfo } = itemsComponents;
  const { AuthCard } = authComponents;
  const { BusyOverlay } = commonComponents;
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [callingAPI, setCallingAPI] = useState(false);
  const [logging, setLogging] = useState(false);
  const [form] = Form.useForm();

  const locale = useSelector((state) => state.system.locale);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const isLoading = useSelector((state) => state.system.isLoading);

  const query = convertStringToQuery(window.location.search);

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    if (userInfo?.email) {
      if (userInfo?.block || (!userInfo?.is_factor2 && userInfo?.is_require_2fa)) {
        global.navigate('SETUP_2FA')
      }  else if (!userInfo?.is_pwd_manager) {
        global.navigate('CREATE_MASTER_PASSWORD')
      }
    }
  }, [userInfo?.email])

  const fetchData = async () => {
    setLoading(true)
    await fetchUserInfo();
    setLoading(false)
  }

  const handleUnlock = async () => {
    setCallingAPI(true)
    const password = form.getFieldValue('masterPassword')
    await userServices.new_session({
      password: password,
      email: userInfo.email,
      kdf: userInfo.kdf,
      kdf_iterations: userInfo.kdf_iterations,
      kdf_memory: userInfo.kdf_memory,
      kdf_parallelism: userInfo.kdf_parallelism
    }).then(async (response) => {
      await commonServices.update_auth_info({
        ...response,
        password,
        username: userInfo?.email
      });
      await commonServices.sync_profile();
      const returnRouter = getReturnRouter()
      await commonServices.sync_data({ returnRouter });
    }).catch((error) => {
      global.pushError(error)
    });
    setCallingAPI(false)
  }

  const getReturnRouter = () => {
    const returnUrl = query?.return_url ? decodeURIComponent(query?.return_url) : '/';
    if (returnUrl) {
      const search = returnUrl.split('?')[1] || '';
      return getRouterByLocation({ pathname: returnUrl, search: search ? `?${search}` : '' })
    }
    return null
  }

  const handleLogout = async () => {
    setLogging(true);
    await authServices.logout();
    setLogging(false);
  }

  return (
    <div
      className="lock-page"
    >
      {
        (isLoading || loading) && <BusyOverlay />
      }
      {
        !(isLoading || loading) && <AuthCard
          className="w-[600px]"
        >
          <div className="w-full">
            <div className="text-center">
              <p className="text-2xl font-semibold">
                { t('lock.title') }
              </p>
              <p className="mb-6 mt-2">{t('lock.description')}</p>
            </div>
            <Form
              form={form}
              key={locale}
            >
              <div className="mt-6 mb-10 flex items-center justify-center">
                <UserInfo />
              </div>
              <Form.Item
                name="masterPassword"
                noStyle
                rules={[
                  global.rules.REQUIRED(t('lock.master_password')),
                ]}
              >
                <Input.Password
                  placeholder={t('lock.master_password')}
                  size="large"
                  disabled={callingAPI || logging}
                  onPressEnter={handleUnlock}
                />
              </Form.Item>
              <p className="font-semibold text-primary mt-2 cursor-pointer">
                {t('lock.master_password_hint')}
              </p>
              <Row gutter={[8, 0]}>
                <Col span={12} >
                  <Button
                    className="w-full mt-6"
                    size="large"
                    htmlType="submit"
                    disabled={callingAPI}
                    loading={logging}
                    onClick={() => handleLogout()}
                  >
                    {t('sidebar.logout')}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    className="w-full mt-6"
                    size="large"
                    type="primary"
                    htmlType="submit"
                    disabled={logging}
                    loading={callingAPI}
                    onClick={handleUnlock}
                  >
                    {t('lock.unlock')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </AuthCard>
      }
    </div>
  );
}

export default Lock;